// Generated by purs version 0.13.8
"use strict";
var Control_Applicative = require("../Control.Applicative/index.js");
var Control_Semigroupoid = require("../Control.Semigroupoid/index.js");
var Data_Either = require("../Data.Either/index.js");
var Data_Eq = require("../Data.Eq/index.js");
var Data_Functor = require("../Data.Functor/index.js");
var Data_Maybe = require("../Data.Maybe/index.js");
var Data_Monoid = require("../Data.Monoid/index.js");
var Data_Show = require("../Data.Show/index.js");
var Data_String_CodePoints = require("../Data.String.CodePoints/index.js");
var Data_String_CodeUnits = require("../Data.String.CodeUnits/index.js");
var Formless_Validation = require("../Formless.Validation/index.js");
var Lunarbox_Data_Profile = require("../Lunarbox.Data.Profile/index.js");
var Lunarbox_Data_String = require("../Lunarbox.Data.String/index.js");
var Required = (function () {
    function Required() {

    };
    Required.value = new Required();
    return Required;
})();
var TooShort = (function () {
    function TooShort(value0) {
        this.value0 = value0;
    };
    TooShort.create = function (value0) {
        return new TooShort(value0);
    };
    return TooShort;
})();
var TooLong = (function () {
    function TooLong(value0) {
        this.value0 = value0;
    };
    TooLong.create = function (value0) {
        return new TooLong(value0);
    };
    return TooLong;
})();
var NoUppercase = (function () {
    function NoUppercase() {

    };
    NoUppercase.value = new NoUppercase();
    return NoUppercase;
})();
var NoLowecase = (function () {
    function NoLowecase() {

    };
    NoLowecase.value = new NoLowecase();
    return NoLowecase;
})();
var NoDigits = (function () {
    function NoDigits() {

    };
    NoDigits.value = new NoDigits();
    return NoDigits;
})();
var InvalidEmail = (function () {
    function InvalidEmail() {

    };
    InvalidEmail.value = new InvalidEmail();
    return InvalidEmail;
})();
var InvalidUsername = (function () {
    function InvalidUsername() {

    };
    InvalidUsername.value = new InvalidUsername();
    return InvalidUsername;
})();
var showFormError = new Data_Show.Show(function (error) {
    return "\u2716 " + (function () {
        if (error instanceof Required) {
            return "This field is required.";
        };
        if (error instanceof TooShort) {
            return "This field needs at least " + (Data_Show.show(Data_Show.showInt)(error.value0) + " characters.");
        };
        if (error instanceof TooLong) {
            return "This fields cannot include more than " + (Data_Show.show(Data_Show.showInt)(error.value0) + " characters.");
        };
        if (error instanceof InvalidEmail) {
            return "Invalid email address.";
        };
        if (error instanceof InvalidUsername) {
            return "Invalid username.";
        };
        if (error instanceof NoUppercase) {
            return "This field needs at least an uppercase character.";
        };
        if (error instanceof NoLowecase) {
            return "This field needs at least a lowecase character.";
        };
        if (error instanceof NoDigits) {
            return "This field needs at least a digit.";
        };
        throw new Error("Failed pattern match at Lunarbox.Form.Validation (line 25, column 10 - line 33, column 59): " + [ error.constructor.name ]);
    })();
});
var exists = function (dictMonad) {
    return Formless_Validation.hoistFnE_(dictMonad)(Data_Maybe.maybe(new Data_Either.Left(Required.value))(Data_Either.Right.create));
};
var condition = function (predicate) {
    return function (err) {
        return function (value) {
            var $19 = predicate(value);
            if ($19) {
                return Control_Applicative.pure(Data_Either.applicativeEither)(value);
            };
            return new Data_Either.Left(err);
        };
    };
};
var email = function (dictMonad) {
    return Formless_Validation.hoistFnE_(dictMonad)((function () {
        var $20 = Data_Functor.map(Data_Either.functorEither)(Lunarbox_Data_Profile.Email);
        var $21 = condition(Data_String_CodeUnits.contains("@"))(InvalidEmail.value);
        return function ($22) {
            return $20($21($22));
        };
    })());
};
var hasDigit = function (dictMonad) {
    return Formless_Validation.hoistFnE_(dictMonad)(condition(Lunarbox_Data_String.containsDigits)(NoDigits.value));
};
var maxLength = function (dictMonad) {
    return function (length) {
        return Formless_Validation.hoistFnE_(dictMonad)(condition(function ($23) {
            return (function (v) {
                return v <= length;
            })(Data_String_CodePoints.length($23));
        })(new TooLong(length)));
    };
};
var minLength = function (dictMonad) {
    return function (length) {
        return Formless_Validation.hoistFnE_(dictMonad)(condition(function ($24) {
            return (function (v) {
                return v >= length;
            })(Data_String_CodePoints.length($24));
        })(new TooShort(length)));
    };
};
var needsLowecase = function (dictMonad) {
    return Formless_Validation.hoistFnE_(dictMonad)(condition(Lunarbox_Data_String.hasLowecase)(NoLowecase.value));
};
var needsUppercase = function (dictMonad) {
    return Formless_Validation.hoistFnE_(dictMonad)(condition(Lunarbox_Data_String.hasUppercase)(NoUppercase.value));
};
var required = function (dictEq) {
    return function (dictMonoid) {
        return function (dictMonad) {
            return Formless_Validation.hoistFnE_(dictMonad)(condition(function (v) {
                return Data_Eq.notEq(dictEq)(v)(Data_Monoid.mempty(dictMonoid));
            })(Required.value));
        };
    };
};
var emailValidators = function (dictMonad) {
    return Control_Semigroupoid.composeFlipped(Formless_Validation.semigroupoidValidation(dictMonad))(required(Data_Eq.eqString)(Data_Monoid.monoidString)(dictMonad))(Control_Semigroupoid.composeFlipped(Formless_Validation.semigroupoidValidation(dictMonad))(minLength(dictMonad)(3))(Control_Semigroupoid.composeFlipped(Formless_Validation.semigroupoidValidation(dictMonad))(maxLength(dictMonad)(32))(email(dictMonad))));
};
var passwordValidators = function (dictMonad) {
    return Control_Semigroupoid.composeFlipped(Formless_Validation.semigroupoidValidation(dictMonad))(required(Data_Eq.eqString)(Data_Monoid.monoidString)(dictMonad))(Control_Semigroupoid.composeFlipped(Formless_Validation.semigroupoidValidation(dictMonad))(minLength(dictMonad)(8))(Control_Semigroupoid.composeFlipped(Formless_Validation.semigroupoidValidation(dictMonad))(maxLength(dictMonad)(32))(Control_Semigroupoid.composeFlipped(Formless_Validation.semigroupoidValidation(dictMonad))(needsUppercase(dictMonad))(Control_Semigroupoid.composeFlipped(Formless_Validation.semigroupoidValidation(dictMonad))(needsLowecase(dictMonad))(hasDigit(dictMonad))))));
};
var usernameValidators = function (dictMonad) {
    return Control_Semigroupoid.composeFlipped(Formless_Validation.semigroupoidValidation(dictMonad))(required(Data_Eq.eqString)(Data_Monoid.monoidString)(dictMonad))(Control_Semigroupoid.composeFlipped(Formless_Validation.semigroupoidValidation(dictMonad))(minLength(dictMonad)(3))(Control_Semigroupoid.composeFlipped(Formless_Validation.semigroupoidValidation(dictMonad))(maxLength(dictMonad)(32))(Formless_Validation.hoistFnE_(dictMonad)(function ($25) {
        return Data_Either.Right.create(Lunarbox_Data_Profile.Username($25));
    }))));
};
module.exports = {
    Required: Required,
    TooShort: TooShort,
    TooLong: TooLong,
    NoUppercase: NoUppercase,
    NoLowecase: NoLowecase,
    NoDigits: NoDigits,
    InvalidEmail: InvalidEmail,
    InvalidUsername: InvalidUsername,
    condition: condition,
    required: required,
    exists: exists,
    maxLength: maxLength,
    minLength: minLength,
    needsUppercase: needsUppercase,
    needsLowecase: needsLowecase,
    hasDigit: hasDigit,
    email: email,
    passwordValidators: passwordValidators,
    emailValidators: emailValidators,
    usernameValidators: usernameValidators,
    showFormError: showFormError
};
